import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './auth/auth.guard';
import { roleGuard } from './auth/role.guard';
import { NgModule } from '@angular/core';
import {UserRolesEnum} from './auth/user_roles.enum';

export const routes: Routes = [
  { path: 'login', loadComponent: () => import('./pages/auth/login.page').then(m => m.LoginPage) },
  //{ path: 'register', loadComponent: () => import('./pages/auth/register.page').then(m => m.RegisterPage) },
  { path: 'register', redirectTo: 'login', pathMatch: 'full' },
  { path: 'auth/callback', loadComponent: () => import('./pages/auth/google-auth-callback.component').then(m => m.AuthCallbackComponent)},
  //{ path: 'welcome', canMatch: [authGuard], loadComponent: () => import('./pages/welcome/welcome.component').then(m => m.WelcomeComponent) },
  //{ path: 'forbidden', loadComponent: () => import('./pages/forbidden.page').then(m => m.ForbiddenPage) },


  {
    path: '',
    canMatch: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'welcome' },
      { path: 'welcome', canMatch: [authGuard], loadComponent: () => import('./pages/welcome/welcome.component').then(m => m.WelcomeComponent) },
      { path: 'dashboard', canMatch: [authGuard], loadComponent: () => import('./pages/welcome/welcome.component').then(m => m.WelcomeComponent) },
      { path: 'forbidden', loadComponent: () => import('./pages/forbidden/forbidden.component').then(c => c.ForbiddenComponent)}

      /*{
        path: 'admin',
        canMatch: [roleGuard],
        data: { roles: ['admin'] },
        loadComponent: () => import('./pages/admin.page').then(m => m.AdminPage)
      }*/
    ]
  },
  {
    path: 'settings',
    canMatch: [authGuard, roleGuard],
    data: {roles: [UserRolesEnum.USER, UserRolesEnum.ADMIN, UserRolesEnum.SUPER_ADMIN]},
    loadChildren: () => import('./modules/settings/settings-routing.module').then(r => r.routes)
  },
  {
    path: 'products',
    canMatch: [authGuard, roleGuard],
    data: {roles: [UserRolesEnum.USER, UserRolesEnum.ADMIN, UserRolesEnum.SUPER_ADMIN]},
    loadChildren: () => import('./modules/products/products-routing.module').then(r => r.routes)
  }
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
